/* Open Cart Drawer */
document.addEventListener("DOMContentLoaded", () => {
  function openCartDrawer() {
    const cartDrawer = document.querySelector(".cart-drawer");
    if (cartDrawer) {
      cartDrawer.setAttribute("open", "");
    }
  }
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get("openCart") === "true") {
    openCartDrawer();
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const init = () => {
    const cartDrawer = document.querySelector(".cart-drawer");

    if (!cartDrawer) {
      // Wenn der Drawer noch nicht da ist, alle 1000ms checken (max. 3s)
      const interval = setInterval(() => {
        const cartDrawerCheck = document.querySelector(".cart-drawer");
        if (cartDrawerCheck) {
          clearInterval(interval);
          callbackWithDrawer(cartDrawerCheck);
        }
      }, 1000); // alle 300ms checken, ob CartDrawer jetzt da ist.

      setTimeout(() => clearInterval(interval), 2000); // Nach 10 Sekunden / 1000ms abbrechen.
      return;
    }

    callbackWithDrawer(cartDrawer);
  };
  init();
});

function callbackWithDrawer(cartDrawer) {

  const gclid = new URLSearchParams(window.location.search).get("gclid");
  const wbraid = new URLSearchParams(window.location.search).get("wbraid");
  const gbraid = new URLSearchParams(window.location.search).get("gbraid");

  if (gclid || wbraid || gbraid) {
    localStorage.setItem("ref", window.location.href); // href, statt das gesamte Location Objekt.
  }

  if (gclid) {
    localStorage.setItem("refgid", gclid);
  }

  if (wbraid) {
    localStorage.setItem("refwbid", wbraid);
  }

  if (gbraid) {
    localStorage.setItem("refgbid", gbraid);
  }  
  
  const storedGclid = localStorage.getItem("ref");
  const storedGid = localStorage.getItem("refgid");
  const storedGbid = localStorage.getItem("refgbid");
  const storedWbid = localStorage.getItem("refwbid");
  const storedConsent = localStorage.getItem("refConsent");

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        const refConsNode = document.getElementById("refcons");
        if (storedConsent && refConsNode) {
          refConsNode.value = storedConsent;
        } else {
          refConsNode.value = "deny";
        }

        const refGidNode = document.getElementById("refgid");
        if (storedGid && refGidNode) {
          refGidNode.value = storedGid;
        }

        const refGbidNode = document.getElementById("refgbid");
        if (storedGbid && refGbidNode) {
          refGbidNode.value = storedGbid;
        }

        const refWbidNode = document.getElementById("refwbid");
        if (storedWbid && refWbidNode) {
          refWbidNode.value = storedWbid;
        }

        const refIdNode = document.getElementById("refid");
        if (storedGclid && refIdNode) {
          //if(storedConsent === 'allow'){
          //  refIdNode.value = 'consent';
          //}
          //else{
          refIdNode.value = storedGclid;
          //}
        }
      }
    }
  });

  observer.observe(cartDrawer, {
    childList: true,
    subtree: true,
  });
}